







import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';

@Component
export default class AccountTransferReportDialog extends Vue {
 @Prop({ default: null }) public template: Common.ReportTemplate;
  public query : Common.AccountTransferReportQuery = new Common.AccountTransferReportQuery();
  public transferMonth: Date = null;

  public mounted(){
    var date1 = new Date().getCalendarDate();
    this.transferMonth = new Date(date1.getFullYear(),date1.getMonth(),1);
  }

  public async onReportGenerate(){
    // クエリの設定
    this.query.templateId = this.template.id;
    this.query.transferMonth = this.transferMonth;
    this.query.onExcelFormat = true;

    this.$api.download(this.query);
  }
  public onHidden(){
      this.$emit('hidden');
  }  
}
